import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './zoom.js';
import { redirectUri, clientId, authority } from './Config.js';
import App from './App';
import { PublicClientApplication, EventType } from '@azure/msal-browser';

const pca = new PublicClientApplication({

    auth: {
        clientId: clientId,
        redirectUri: redirectUri,
        authority: authority,
    }
});

pca.addEventCallback((message) => {
    if (message.eventType === EventType.LOGIN_SUCCESS) {
        //console.log(message);
        pca.setActiveAccount(message.payload.account);
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>

        <App msalInstance={pca} />

    </React.StrictMode>
);
